import { render, staticRenderFns } from "./table-data-tag-cell.vue?vue&type=template&id=5b9f6f87&"
import script from "./table-data-tag-cell.vue?vue&type=script&lang=js&"
export * from "./table-data-tag-cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports